import React from 'react';
import { CustomLayoutProvider } from './CustomLayoutContext';
import CustomLayout from './CustomLayout';

export const CustomLayoutWrapper = (props) => {
  return (
    <CustomLayoutProvider>
      <CustomLayout {...props} />
    </CustomLayoutProvider>
  );
};
